 
 import { Html } from "../assets";
import ayanpic from "../assets/images/ayan.png"
import { blog1, blog2 } from "./html-blogs";
 export let html = [
    {
      videoId: "dKxbrmmoNmA",
      time: "4:43",
      icon: Html,
      url: "html-Introduction",
      heading: "HTML Introduction Class 01",
      description: "Learn the fundamentals of HTML in this introductory class.",
      blog:blog1,
    },
    {
      videoId: "vV1iLWz7wcc",
      time: "30:02",
      icon: Html,
      url: "html-structure",
      heading: "HTML Structure Class 02",
      description: "Explore the structure and layout components of HTML.",
      blog: blog2
    },
    {
      videoId: "RYq8D4CPCrI",
      time: "10:04",
      icon: Html,
      url: "html-basic-tags",
      heading: "Basic Tags of HTML 05 Class 03",
      description: "Understand the essential tags used in HTML for building web content.",
      blog:blog1
    },
    {
      videoId: "5YOCJisdX_0",
      time: "17:50",
      icon: Html,
      url: "html-forms-&-input-tags",
      heading: "HTML Tutorial: Forms & Input Tags class 04",
      description: "Discover how to create forms and input tags in HTML.",
      blog: blog1
    },
    {
      videoId: "aBS21mogYsg",
      time: "19:04",
      icon: Html,
      url: "html-tutorial-anchor-tag",
      heading: "HTML Tutorial: Anchor tag | Class 05",
      description: "Master the usage of anchor tags for creating hyperlinks in HTML.",
      blog:blog1
    },
    {
      videoId: "OZFpsy5NxR8",
      time: "06:43",
      icon: Html,
      url: "html-img-tag",
      heading: "HTML Tutorial: Img tag | Class 06",
      description: "Learn how to insert and manipulate images using the img tag in HTML.",
      blog:blog1
    },
    {
      videoId: "qmO8L5Y_4aQ",
      time: "07:54",
      icon: Html,
      url: "html-iframe-tag-attribute",
      heading: "Iframe tag attribute - HTML 5 tutorial | Class 07",
      description: "Explore the iframe tag and its attributes for embedding content in HTML.",
      blog:blog1
    },
  ];